
import { Component, Watch, Vue } from "vue-property-decorator";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Steps from "@/components/recipe-detail/Steps.vue";
import Ingredients from "@/components/recipe-detail/Ingredients.vue";
import Label from "@/components/recipe-detail/Label.vue";
import Packing from "@/components/recipe-detail/Packing.vue";
import eventBus from "@/services/eventBus";
import RecipeService, { FullData, Recipe } from "@/services/recipes.service";
import { GenericResponse } from "@/services/interceptors";
import NameInput from "@/components/recipe-detail/NameInput.vue";
import Cookies from "js-cookie";
import BlockableSection from "@/components/BlockableSection.vue";
import FullScreenOverlay from "@/components/FullScreenOverlay.vue";

@Component({
  components: {
    Header,
    Footer,
    Sidebar,
    Steps,
    Ingredients,
    Packing,
    Label,
    NameInput,
    BlockableSection,
    FullScreenOverlay,
  },
})
export default class RecipeDetail extends Vue {
  data() {
    return {
      model: null,
      originalModel: null,
      showBlockedOverlay: false,
    };
  }

  created(): void {
    this.loadModel(Number.parseInt(this.$route.params.id));
  }

  loadModel(id: number): void {
    RecipeService.getOneFull(id)
      .then((model: FullData) => {
        this.$data.model = model.label;
        this.$data.originalModel = model;

        this.$store.commit("updateRecipe", model.label);
        this.$store.commit("updateTable", model.table);
      })
      .catch((error) => {
        this.$data.model = null;
        this.$router.push("/home");
      });
  }
}
